export const withBackend = true;

export const appTitle = 'Lunch Lottery Admin';

export const host =
  process.env.REACT_APP_HOST || 'https://app.lunch-lottery.com';
